/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { Comment } from 'antd';
import classNames from 'classnames/bind';
import React, { useState, FC } from 'react';
import { EditorModes } from 'data/documents';
import { useDocuments } from '../../document-store';
import { Content, TextFromDoc, ReplyComment } from './discussions-components';
import { CommentHead } from './discussions-components/comment-head';
import {
  useDiscussions,
  deleteCommmentOnStore,
  deleteThreadOnStore,
  resolveThreadOnStore,
} from './discussions-store';
import styles from './doc-discussions.module.css';
import { DiscussionProps } from './types';

export const Discussion: FC<DiscussionProps> = ({
  projectId,
  docId,
  discussion,
  isActiveDiscussion,
  editorCommentMap,
  onDiscussionClick,
}) => {
  const [, dispatch] = useDiscussions();
  const [editingComment, setEditingComment] = useState(0);
  const [state] = useDocuments();

  const renderHiddenCommentsInfo = (value) =>
    `${value} comment${value > 1 ? 's' : ''}`;

  const enableEditComment = (comment) => {
    setEditingComment(comment.commentId);
  };

  const deleteCommment = (comment) => {
    deleteCommmentOnStore(dispatch, { projectId, docId, comment });
  };

  const deleteFromDoc = (commentThreadId) => {
    const options = {
      commentId: `rl-comment-${commentThreadId}`,
    };

    if (state.allEditors) {
      state.allEditors[EditorModes.Private]?.execute(
        'removeCommentCommand',
        options,
      );
      state.allEditors[EditorModes.Public]?.execute(
        'removeCommentCommand',
        options,
      );
    }
  };
  const onPerformThreadDelete = (comment) => {
    deleteThreadOnStore(dispatch, { projectId, docId, comment });
    deleteFromDoc(comment?.commentThreadId);
  };

  const onPerformThreadResolve = (comment) => {
    resolveThreadOnStore(dispatch, { projectId, docId, comment });
    deleteFromDoc(comment?.commentThreadId);
  };

  const cx = classNames.bind(styles);
  /* eslint-disable @typescript-eslint/naming-convention */
  const generateDiscussionClasses = (index, discussionLength) =>
    cx('comment', {
      comment__intermediate: index !== 0 && index !== discussionLength - 1,
      comment__intermediate__info: index === discussionLength - 2,
    });
  /* eslint-enable @typescript-eslint/naming-convention */

  return (
    <div
      className={cx(
        'discussion',
        { active: isActiveDiscussion },
        // eslint-disable-next-line @typescript-eslint/naming-convention
        { discussion__private: discussion.comments[0]?.private },
      )}
      onClick={onDiscussionClick}
      id={`commentThread-rl-comment-${discussion.commentThread.threadId}`}
    >
      <TextFromDoc
        linkedId={discussion.commentThread.threadId.toString()}
        content={editorCommentMap[discussion.commentThread.threadId]?.content}
        contentType={discussion.comments[0]?.private ? 'private' : 'public'}
      />
      {discussion.comments.map((comment, index) => (
        <div key={comment.commentId}>
          <Comment
            className={generateDiscussionClasses(
              index,
              discussion.comments.length,
            )}
            author={
              <CommentHead
                shouldHide={editingComment === comment.commentId}
                isThreadComment={index === 0}
                actionClass={styles.actions}
                comment={comment}
                authorClass={styles.author}
                onPerformDelete={deleteCommment}
                onPerformEdit={enableEditComment}
                onPerformThreadDelete={onPerformThreadDelete}
                onPerformThreadResolve={onPerformThreadResolve}
              />
            }
            content={
              <Content
                edit={editingComment === comment.commentId}
                onEditFormClose={() => setEditingComment(0)}
                comment={comment}
                docId={docId}
                projectId={projectId}
                isPrivateDiscussion={discussion.comments[0]?.private}
                isActiveDiscussion={isActiveDiscussion}
              />
            }
          />
          {index === discussion.comments.length - 2 &&
          discussion.comments.length > 2 ? (
            <div className={styles.hidden__comments_info}>
              {renderHiddenCommentsInfo(discussion.comments.length - 2)}
            </div>
          ) : null}
        </div>
      ))}
      <div className={!isActiveDiscussion ? 'hide' : ''}>
        <ReplyComment
          fromPrivateDiscussion={discussion.comments[0]?.private}
          discussionThreadId={discussion.commentThread.threadId}
          isPrivateComment={discussion.comments[0]?.private}
          docId={docId}
          projectId={projectId}
        />
      </div>
    </div>
  );
};
